<template>
  <div>
    <v-row>
      <v-col cols="12">
        <label style="font-weight: bold">{{
          $t("Panier.SectionDocumentRequis.TitreSectionDocuments")
        }}</label>
      </v-col>
    </v-row>
    <v-row
      v-for="document in documents"
      v-bind:key="document.id"
    >
      <v-col
        cols="10"
        sm="8"
        class="py-0 pr-1"
      >
        <v-file-input
          v-model="document.value"
          outlined
          dense
          hide-details="auto"
          :accept="ExtensionPermise"
          :rules="[
            ...regles.extensionPermise,
            ...regles.tailleMax,
            ...regles.vide
          ].concat(estDocumentObligatoire(document) ? [...regles.fichier] : [])"
          :label="document.typeDocument.identifiant + (estDocumentObligatoire(document) ? ' (obligatoire)' : '')"
        ></v-file-input>
      </v-col>
      <v-col
        cols="2"
        class="pt-2"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <span>{{$tc('Panier.SectionDocumentRequis.ExtensionPermise')}}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';
import csqcoutils from '../../outils/CSQCOutils';

export default {
  name: 'DocumentsRequis',
  props: {
    documents: Array,
    scolariseMaison: Boolean,
  },
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
      regles: {
        extensionPermise: [(value) => this.validerExtension(value) || this.$t('erreurs.extension_non_permise')],
        tailleMax: [(value) => this.validerTailleTropGrande(value) ||
          `${this.$t('erreurs.fichierTailleMax') + csqcoutils.TailleMax() / 1048576} Mo`],
        vide: [(value) => this.validerEstVide(value) || this.$t('erreurs.fichierVide')],
        fichier: [(value) => !!value || this.$t('erreurs.FichierRequis')],
      },
    };
  },
  methods: {
    validerExtension(fichier) {
      if (fichier != null) {
        const ext = csqcoutils.ExtraireExtension(fichier);
        if (this.appStore.modele.extensionsPermise.includes(ext.toLowerCase()) === false) return false;
      }
      return true;
    },
    validerTailleTropGrande(fichier) {
      if (fichier != null) {
        if (fichier.size > csqcoutils.TailleMax()) return false;
      }
      return true;
    },
    validerEstVide(fichier) {
      if (fichier != null) {
        if (fichier.size <= 0) return false;
      }
      return true;
    },
    estDocumentObligatoire(document) {
      return (this.scolariseMaison && document.scolariseMaison) || (!this.scolariseMaison && document.obligatoire);
    },
  },
  computed: {
    ExtensionPermise() {
      let resultat = '';
      this.appStore.modele.extensionsPermise.forEach((element) => {
        resultat += `.${element},`;
      });
      resultat = resultat.slice(0, -1);
      return resultat;
    },
  },
  watch: {
    documents() {
      this.$emit('input', this.documents);
    },
  },
};
</script>
